<template>
    <b-card>
        <b-card-body>
            <h4 class="mb-4">Send E-Mail to Registrant</h4>

            <b-form-row>
                <b-col>
                    <b-form-group>
                        <label>Subject <span class="required">*</span></label>
                        <b-form-input v-model="comm.subject"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-form-row>
            <b-form-row>
                <b-col>
                    <quill-editor v-model="comm.body" ref="myQuillEditor" :options="editorOption"/>
                </b-col>
            </b-form-row>

            <div class="mt-5">
                <b-button variant="success"><i class="fas fa-envelope mr-3"></i>Send E-Mail</b-button>
            </div>

        </b-card-body>
    </b-card>
</template>

<script>
    export default {
        name: "Communicate",
        data: function() {
            return {
                comm: {

                },
                editorOption: {
                    // some quill options
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
    @import '~@/assets/scss/_variables.scss';

    .quill-editor {
        .ql-toolbar {
            border: 1px solid #e5e5e5;
            border-top-left-radius: 0.2rem;
            border-top-right-radius: 0.2rem;
        }

        .ql-container {
            border: 1px solid #e5e5e5;
            border-bottom-left-radius: 0.2rem;
            border-bottom-right-radius: 0.2rem;

            max-height: 400px;
            overflow-y: auto;
        }

        p {
            margin-bottom: 1rem;
        }
    }

    .required {
        color: red;
    }
</style>